import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

//* ~~~~~~ INTEGRATIONS ROUTES ~~~~~~

// Gets integrations
export const getIntegrations = async () => {
  return await wrapCall({ method: callGet, uri: '/integrations' })
}

// Create new integrations
export const postIntegration = async data => {
  return await wrapCall({ method: callPost, uri: '/integrations', data })
}

// Gets a single integration by id
export const getIntegration = async id => {
  return await wrapCall({ method: callGet, uri: `/integrations/${id}` })
}

// Update an integration
export const putIntegration = async (id, data) => {
  return await wrapCall({ method: callPut, uri: `/integrations/${id}`, data })
}

// Delete an integration
export const deleteIntegration = async id => {
  return await wrapCall({ method: callDelete, uri: `/integrations/${id}` })
}

//* ~~~~~~ INBOX RELATED ~~~~~~

// Gets integration inboxes
export const getInboxes = async () => {
  return await wrapCall({ method: callGet, uri: `/integrations/inboxes` })
}
